module.exports = __webpack_public_path__ + "img/flutter.fab57e1f.svg";